(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solvivo-product-mobile"] && !Shopify.designMode) return;
  try {
    class SolvivoProductMobile extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.bar = this.section?.querySelector('.sticky-add-to-cart__bar');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.purchaseObserver = new IntersectionObserver((entries) => {
        document.body.dataset.solvivoPurchaseVisible = String(entries.some((entry) => entry.isIntersecting));
      });
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-stuck', 'data-variant-available', 'hidden', 'aria-hidden', 'open'] });
      this.resize = new ResizeObserver(this.schedule);
      this.bannerObserver = new MutationObserver(this.schedule);
      if (this.bar) this.resize.observe(this.bar);
      this.resize.observe(document.documentElement);
      this.schedule();
    }
    update() {
      const purchase = this.section?.querySelector('.product-form-buttons');
      if (purchase !== this.purchase) {
        this.purchaseObserver.disconnect();
        this.purchase = purchase;
        if (purchase) this.purchaseObserver.observe(purchase);
        else delete document.body.dataset.solvivoPurchaseVisible;
      }
      const banner = document.querySelector('#shopify-pc__banner');
      if (banner !== this.banner) {
        this.bannerObserver.disconnect();
        if (this.banner) this.resize.unobserve(this.banner);
        this.banner = banner;
        if (banner) {
          this.bannerObserver.observe(banner, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
          this.resize.observe(banner);
        }
      }
      const consentOpen = Boolean(banner && banner.getClientRects().length && getComputedStyle(banner).visibility !== 'hidden');
      const stuck = this.bar?.dataset.stuck === 'true' && this.bar.closest('sticky-add-to-cart')?.dataset.variantAvailable === 'true';
      const offset = stuck && !consentOpen ? Math.ceil(this.bar.getBoundingClientRect().height) + 8 : 0;
      document.body.style.setProperty('--solvivo-purchase-offset', `${offset}px`);
      document.body.dataset.solvivoConsentOpen = String(consentOpen);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.purchaseObserver?.disconnect();
      this.bannerObserver?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.style.removeProperty('--solvivo-purchase-offset');
      delete document.body.dataset.solvivoConsentOpen;
      delete document.body.dataset.solvivoPurchaseVisible;
    }
  }
  if (!customElements.get('solvivo-product-mobile')) customElements.define('solvivo-product-mobile', SolvivoProductMobile);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-button"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-whatsapp-share]').forEach((button) => {
    if (button.dataset.whatsappReady === 'true') return;

    const updateWhatsAppLink = () => {
      const prefix = button.dataset.messagePrefix || '';
      const message = `${prefix} ${document.title} — ${window.location.href}`.trim();
      button.href = `https://wa.me/3908117969779?text=${encodeURIComponent(message)}`;
    };

    updateWhatsAppLink();
    button.addEventListener('click', updateWhatsAppLink);
    button.dataset.whatsappReady = 'true';
  });
  } catch(e) { console.error(e); }
})();

})();
